import { DeliveryTermsContent } from 'features/store/pages/delivery-store-selector/delivery-terms-modal';

export default function DeliveryTermsModalPage() {
  return <DeliveryTermsContent />;
}
